import { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useAuthUserRestaurant,
  useGetSingleRestaurantCompanyQuery,
} from '@durma-soft/gros-sdk';

import { NavLink } from '@/components/shared/nav-link';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/shared/shadcn-ui/breadcrumb';

interface CompanyBreadcrumbProps {
  companyId: number;
  /** Trailing crumbs after "Firme → company name" */
  items?: { label: ReactNode; to: string }[];
}

export const CompanyBreadcrumb = ({
  companyId,
  items = [],
}: CompanyBreadcrumbProps) => {
  const { t } = useTranslation();
  const restaurant = useAuthUserRestaurant();

  const { data: company } = useGetSingleRestaurantCompanyQuery({
    restaurant_id: restaurant.id,
    company_id: companyId,
  });

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <NavLink to="/restaurant/companies">{t('company.title')}</NavLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <NavLink
            to={`/restaurant/companies/${companyId}`}
            className={({ isActive }) => (isActive ? 'text-primary' : '')}
          >
            {company?.name ?? '…'}
          </NavLink>
        </BreadcrumbItem>
        {items.map((item) => (
          <Fragment key={item.to}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <NavLink
                to={item.to}
                className={({ isActive }) => (isActive ? 'text-primary' : '')}
              >
                {item.label}
              </NavLink>
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
